import { render, staticRenderFns } from "./TreemapHub.vue?vue&type=template&id=7c649e20&lang=pug&"
import script from "./TreemapHub.vue?vue&type=script&lang=ts&"
export * from "./TreemapHub.vue?vue&type=script&lang=ts&"
import style0 from "./TreemapHub.vue?vue&type=style&index=0&id=7c649e20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports